// AUTO-GENERATED FILE — DO NOT EDIT MANUALLY
// Source: 16092420_Rehberlik_Hizmetleri_Sunum_Sistemi.xlsx
//
// Bu dosya FAALİYET ÜRETMEZ.
// Yalnızca eski kodlu RPD Hizmetleri Sunum Sistemi
// tablosunda doğrulanabilen faaliyet → MEBBİS kod
// eşleşmelerini içerir.

export const MEBBIS_EXACT_CODE_MAP_VERSION =
  "RPDH-MEBBIS-CODES-V1";


export const MEBBIS_EXACT_CODE_MAP =
{
  "class_guidance_preschool|her bireyin özel alanı olduğunu söyler": "ÖSOİ42",
  "class_guidance_preschool|bireylerin özel alanlarına saygı duyulması gerektiğini fark eder": "ÖSOİ43",
  "class_guidance_preschool|gerektiğinde hayır der": "ÖSOİ44",
  "class_guidance_preschool|zorbalıkla karşılaştığında yapılması gerekenleri söyler": "ÖSOİ46",
  "class_guidance_primary|kişisel sınırlarını korumanın önemini açıklar": "ÖSİİ92",
  "class_guidance_primary|kişisel sınırlarını korur": "ÖSİİ100",
  "class_guidance_primary|öfkenin kontrol edilebilir bir duygu olduğunu fark eder": "ÖSİİ104",
  "class_guidance_primary|öfkesini uygun yollarla ifade eder": "ÖSİİ105",
  "class_guidance_primary|zorbalıkla karşılaştığında baş etme yollarını kullanır": "ÖSİİ102",
  "class_guidance_middle_school|sınav kaygısının performansını düşürecek düzeyde olup olmadığını belirler ve gerekiyorsa yardım alır": "ÖSORE44",
  "class_guidance_middle_school|öfkeyi uygun ve uygun olmayan biçimlerde ortaya koymanın sonuçlarını açıklar": "ÖSORİ115",
  "class_guidance_middle_school|öfkelendiğinde gevşeme ve nefes egzersizlerini kullanır": "ÖSORİ116",
  "class_guidance_middle_school|çatışma durumlarını fark eder": "ÖSORİ118",
  "class_guidance_middle_school|kullandığı çatışma çözme yöntemlerini değerlendirir": "ÖSORİ119",
  "class_guidance_high_school|sınava ilişkin duygularını sınav performansına etkileri açısından değerlendirir": "ÖSLE19",
  "class_guidance_high_school|sınav kaygısıyla başa çıkma yollarını kullanır": "ÖSLE20",
  "class_guidance_high_school|öfkenin yarattığı fiziksel duygusal ve düşünsel etkileri açıklar": "ÖSLİ31",
  "class_guidance_high_school|öfke ile baş etmede kullandığı yöntemleri yarattığı etkileri açısından değerlendirir": "ÖSLİ32",
  "class_guidance_high_school|öfkeyle baş etmede yapıcı yollar kullanır": "ÖSLİ33",
  "class_guidance_high_school|etkili çatışma çözme basamaklarını açıklar": "ÖSLİ34",
  "class_guidance_high_school|günlük hayatında kullandığı çatışma çözme basamaklarını etkililiği açısından değerlendirir": "ÖSLİ35",
  "class_guidance_high_school|akran baskısıyla baş eder": "ÖSLİ36",
  "class_guidance_high_school|fiziksel sözel ve duygusal şiddetle karşılaştığında nereden yardım alabileceğini belirtir": "ÖSLİ39",
  "class_guidance_high_school|fiziksel sözel ve duygusal tacizle karşılaştığında nereden yardım alabileceğini belirtir": "ÖSLİ40",
  "class_guidance_high_school|etkili çatışma çözme basamaklarını kullanır": "ÖSLİ44",
  "class_guidance_high_school|günlük hayatında kullandığı sorun çözme yollarını etkililiği açısından değerlendirir": "ÖSLİ46",
  "class_guidance_high_school|etkili sorun çözme basamaklarını kullanır": "ÖSLİ47",
  "class_guidance_high_school|stresin nedenlerini ve belirtilerini açıklar": "ÖSLG66",
  "class_guidance_high_school|stres durumlarında kullandığı tepkileri etkililiği açısından değerlendirir": "ÖSLG67",
  "class_guidance_high_school|stresle başa çıkmada uygun yöntemler kullanır": "ÖSLG68",
  "class_guidance_high_school|kişisel sınırların farkında olur": "ÖSLÖ34",
  "class_guidance_high_school|kendini koruma becerisi kazanır": "ÖSLÖ35",
  "individual_recognition|okul risk haritası": "S.İ.2.a",
  "individual_recognition|sınıf risk haritası": "S.İ.4.a",
  "individual_recognition|öğrenci bilgi formu": "B.K.G.4.c",
  "individual_recognition|bana kendini anlat": "B.K.O.1.c",
  "individual_recognition|kimdir bu": "B.G.G.5.a",
  "individual_recognition|kime göre ben neyim": "B.G.G.6.a",
  "individual_recognition|sosyometri": "B.G.G.9.a",
  "individual_recognition|çocuğumu tanıyorum": "B.G.G.2.c",
  "individual_recognition|kendimi tanıyorum": "B.K.G.3.c",
  "individual_recognition|şiddet algısı anketi": "B.K.A.7.c",
  "individual_recognition|şiddet sıklığı anketi": "B.K.A.8.c",
  "individual_recognition|şiddet meşruiyeti anketi": "B.K.A.9.c",
  "individual_recognition|şiddet algısı anketi veli": "B.G.G.10.c.",
  "individual_recognition|şiddet sıklığı anketi veli": "B.G.G.11.c.",
  "individual_recognition|şiddet meşruiyeti anketi veli": "B.G.G.12.c.",
  "individual_recognition|şiddet algısı anketi öğretmen": "B.G.G.13.c.",
  "individual_recognition|şiddet sıklığı anketi öğretmen": "B.G.G.14.c.",
  "individual_recognition|şiddet meşruiyeti anketi öğretmen 4 6 sınıf": "B.G.G.15.c.",
  "individual_recognition|şiddet meşruiyeti anketi öğretmen 7 12 sınıf": "B.G.G.16.c.",
  "individual_recognition|devamsızlık nedenleri anketi": "B.K.A.2.c",
  "individual_recognition|riba ilkokul öğrenci formu": "B.K.A.15.a",
  "individual_recognition|riba ortaokul öğrenci formu": "B.K.A.16.a",
  "individual_recognition|riba lise öğrenci formu": "B.K.A.17.a",
  "individual_recognition|riba okulöncesi öğretmen formu": "B.K.A.18.a",
  "individual_recognition|riba ilkokul öğretmen formu": "B.K.A.19.a",
  "individual_recognition|riba ortaokul öğretmen formu": "B.K.A.20.a",
  "individual_recognition|riba lise öğretmen formu": "B.K.A.21.a",
  "individual_recognition|riba okulöncesi veli formu": "B.K.A.22.a",
  "individual_recognition|riba ilkokul veli formu": "B.K.A.23.a",
  "individual_recognition|riba ortaokul veli formu": "B.K.A.24.a",
  "individual_recognition|riba lise veli formu": "B.K.A.25.a",
  "individual_recognition|verimli ders çalışma kontrol listesi": "B.K.İ.1.c",
  "individual_recognition|snellen testi": "B.G.D.1.c",
  "individual_recognition|diğer": "ÖOB2",
  "student_social_emotional|akran arabuluculuğu": "ÖOVKg",
  "student_social_emotional|akran zorbalığı": "ÖOVKg",
  "student_social_emotional|atılganlık": "ÖOVKg",
  "student_social_emotional|bireysel farklılıklara saygı": "ÖOVKg",
  "student_social_emotional|çatışma çözme becerileri": "ÖOVKg",
  "student_social_emotional|çocuklarda cinsel eğitim": "ÖOVKg",
  "student_social_emotional|duygu kontrolü": "ÖOVKg",
  "student_social_emotional|eleştirel düşünme becerisi": "ÖOVKg",
  "student_social_emotional|ergenleri bilgilendirme ve farkındalık kazandırma eğitim programı": "ÖOVKg",
  "student_social_emotional|geleceği planlama": "ÖOVKg",
  "student_social_emotional|gelişim dönemi özellikleri": "ÖOVKg",
  "student_social_emotional|hak ve sorumluluklarını bilme": "ÖOVKg",
  "student_social_emotional|ihmal istismardan korunma": "ÖOVKg",
  "student_social_emotional|iletişim becerileri": "ÖOVKg",
  "student_social_emotional|işbirliği geliştirme": "ÖOVKg",
  "student_social_emotional|karar verme becerisi": "ÖOVKg",
  "student_social_emotional|olumlu davranış geliştirme": "ÖOVKg",
  "student_social_emotional|otokontrol": "ÖOVKg",
  "student_social_emotional|öfke kontrolü": "ÖOVKg",
  "student_social_emotional|öz bakım becerileri": "ÖOVKg",
  "student_social_emotional|özgüven geliştirme": "ÖOVKg",
  "student_social_emotional|özsaygı": "ÖOVKg",
  "student_social_emotional|problem çözme becerileri": "ÖOVKg",
  "student_social_emotional|sosyal beceriler": "ÖOVKg",
  "student_social_emotional|stresle baş etme becerileri": "ÖOVKg",
  "student_social_emotional|şiddeti önleme": "ÖOVKg",
  "student_social_emotional|tbm alkol bağımlılığı": "ÖOVKg",
  "student_social_emotional|tbm madde bağımlılığı": "ÖOVKg",
  "student_social_emotional|tbm sağlıklı yaşam": "ÖOVKg",
  "student_social_emotional|tbm teknoloji bağımlılığı": "ÖOVKg",
  "student_social_emotional|tbm tütün bağımlılığı": "ÖOVKg",
  "student_social_emotional|yaratıcı düşünme becerisi": "ÖOVKg",
  "student_social_emotional|psikososyal önleyici destek programı göç": "ÖOVKg",
  "student_social_emotional|psikososyal önleyici destek programı cinsel istismar": "ÖOVKg",
  "student_social_emotional|psikososyal önleyici destek programı intihar": "ÖOVKg",
  "student_social_emotional|psikososyalönleyici destek programı terör": "ÖOVKg",
  "student_social_emotional|psikososyal önleyici destek programı doğal afet": "ÖOVKg",
  "student_social_emotional|psikososyal önleyici destek programı ölüm yas": "ÖOVKg",
  "student_academic|çalışma programı hazırlama": "ÖOVEg",
  "student_academic|ders seçimi": "ÖOVEg",
  "student_academic|devamsızlığı önleme": "ÖOVEg",
  "student_academic|dikkat geliştirme çalışmaları": "ÖOVEg",
  "student_academic|hedef belirleme": "ÖOVEg",
  "student_academic|motivasyon": "ÖOVEg",
  "student_academic|okul kuralları": "ÖOVEg",
  "student_academic|okula ve çevreye uyum": "ÖOVEg",
  "student_academic|okulun fiziksel imkanları": "ÖOVEg",
  "student_academic|okulda seçilebilecek alan dallar": "ÖOVEg",
  "student_academic|okuldaki ve okul çevresindeki eğitim olanakları": "ÖOVEg",
  "student_academic|okullara sınavlara başvuru kılavuzları": "ÖOVEg",
  "student_academic|okulun sosyokültürel imkanları": "ÖOVEg",
  "student_academic|öğrenciyi ilgilendiren yönetmelikler": "ÖOVEg",
  "student_academic|öğrenme stilleri": "ÖOVEg",
  "student_academic|öz disiplin geliştirme": "ÖOVEg",
  "student_academic|rehberlik servisinin tanıtılması": "ÖOVEg",
  "student_academic|serbest zamanı değerlendirme": "ÖOVEg",
  "student_academic|sınav kaygısı": "ÖOVEg",
  "student_academic|sınavda başarılı olma stratejileri": "ÖOVEg",
  "student_academic|sınavlarda başarılı olma ve çalışma yolları": "ÖOVEg",
  "student_academic|üst öğrenim kurumlarında tercih edilebilecek alan dallar": "ÖOVEg",
  "student_academic|üst öğrenim kurumlarının tanıtılması": "ÖOVEg",
  "student_academic|üst öğrenimde yararlanılacak burslar ve barınma olanakları": "ÖOVEg",
  "student_academic|üst öğrenime geçiş sınavları": "ÖOVEg",
  "student_academic|verimli ders çalışma teknikleri": "ÖOVEg",
  "student_academic|yurt dışı eğitim olanakları": "ÖOVEg",
  "student_academic|zaman yönetimi": "ÖOVEg",
  "student_academic|zeka türleri ve özellikleri": "ÖOVEg",
  "student_career|bir meslek elemanını sınıfa okula davet etme": "ÖOVMg",
  "student_career|çalışan işveren hak ve sorumlulukları": "ÖOVMg",
  "student_career|çevredeki iş olanakları ve çalışma koşulları": "ÖOVMg",
  "student_career|iş görüşmesi becerileri": "ÖOVMg",
  "student_career|iş ve mesleğe hazırlayan kurum ve kursların tanıtımı": "ÖOVMg",
  "student_career|iş ve meslek etiği": "ÖOVMg",
  "student_career|iş yaşamına yönelik beceriler": "ÖOVMg",
  "student_career|kariyer planlama": "ÖOVMg",
  "student_career|meslek sahibi olmanın önemi": "ÖOVMg",
  "student_career|meslek seçerken dikkat edilmesi gereken hususlar": "ÖOVMg",
  "student_career|meslek tanıtımı": "ÖOVMg",
  "student_career|meslek ve değer ilişkisi": "ÖOVMg",
  "student_career|meslek ve ilgi ilişkisi": "ÖOVMg",
  "student_career|meslek ve kişisel özellik ilişkisi": "ÖOVMg",
  "student_career|meslek ve yetenek ilişkisi": "ÖOVMg",
  "student_career|mesleki hedef belirleme": "ÖOVMg",
  "student_career|özgeçmiş hazırlama": "ÖOVMg",
  "student_career|staj": "ÖOVMg",
  "orientation_monitoring|seçmeli ders": "ÖOY",
  "orientation_monitoring|sosyal kulüpler": "ÖOY",
  "orientation_monitoring|sosyal ve kültürel faaliyetler": "ÖOY",
  "psychosocial_intervention|psikososyal güçlendirici destek programı cinsel istismar": "İpg",
  "psychosocial_intervention|psikososyal güçlendirici destek programı intihar": "İpg",
  "psychosocial_intervention|psikososyal güçlendirici destek programı terör": "İpg",
  "psychosocial_intervention|psikososyal güçlendirici destek programı doğal afet": "İpg",
  "psychosocial_intervention|psikososyal güçlendirici destek programı ölüm yas": "İpg",
  "parent_support|aile içi iletişim": "DMVE",
  "parent_support|akran arabuluculuğu": "DMVE",
  "parent_support|akran zorbalığı": "DMVE",
  "parent_support|alan dal tanıtımı ve seçimi": "DMVE",
  "parent_support|anne baba tutumları": "DMVE",
  "parent_support|atılganlık": "DMVE",
  "parent_support|baba destek programı": "DMVE",
  "parent_support|bilsem tanıtımı": "DMVE",
  "parent_support|bireysel farklılıklara saygı": "DMVE",
  "parent_support|çatışma çözme becerileri": "DMVE",
  "parent_support|çevredeki iş olanakları ve çalışma koşulları": "DMVE",
  "parent_support|çocuk ve ergenlerin gelişim özellikleri": "DMVE",
  "parent_support|çocuklar ve oyun": "DMVE",
  "parent_support|çocuklarda cinsel eğitim": "DMVE",
  "parent_support|çocuklarda öz disiplin geliştirme": "DMVE",
  "parent_support|davranış sorunları": "DMVE",
  "parent_support|ders seçimi": "DMVE",
  "parent_support|devamsızlığı önleme": "DMVE",
  "parent_support|dikkat geliştirme çalışmaları": "DMVE",
  "parent_support|ebeveynlik becerileri": "DMVE",
  "parent_support|engel türleri ve tanılama süreçleri": "DMVE",
  "parent_support|geleceği planlama": "DMVE",
  "parent_support|hak ve sorumluluklarını bilme": "DMVE",
  "parent_support|hedef belirleme": "DMVE",
  "parent_support|ihmal istismardan korunma": "DMVE",
  "parent_support|iletişim becerileri": "DMVE",
  "parent_support|iş yaşamına yönelik beceriler": "DMVE",
  "parent_support|işbirliği geliştirme": "DMVE",
  "parent_support|karar verme becerisi": "DMVE",
  "parent_support|kariyer planlama": "DMVE",
  "parent_support|kuşaklararası iletişim": "DMVE",
  "parent_support|meslek ve değer ilişkisi": "DMVE",
  "parent_support|meslek ve ilgi ilişkisi": "DMVE",
  "parent_support|meslek ve kişisel özellik ilişkisi": "DMVE",
  "parent_support|meslek ve yetenek ilişkisi": "DMVE",
  "parent_support|motivasyon": "DMVE",
  "parent_support|okul başarısında ailenin rolü": "DMVE",
  "parent_support|okul olgunluğu": "DMVE",
  "parent_support|okula uyum çalışmaları": "DMVE",
  "parent_support|olumlu davranış geliştirme": "DMVE",
  "parent_support|öfke yönetimi": "DMVE",
  "parent_support|öğrenciyi ilgilendiren yönetmelikler": "DMVE",
  "parent_support|öğrenme stilleri": "DMVE",
  "parent_support|özel eğitim gereksinimli öğrencilerin eğitim olanakları": "DMVE",
  "parent_support|özel eğitim gereksinimli öğrencilerin gelişim özellikleri": "DMVE",
  "parent_support|özgüven geliştirme": "DMVE",
  "parent_support|özsaygı geliştirme": "DMVE",
  "parent_support|problem çözme becerileri": "DMVE",
  "parent_support|psikososyal destek programı göç": "DMVE",
  "parent_support|psikososyal destek programı cinsel istismar": "DMVE",
  "parent_support|psikososyal destek programı intihar": "DMVE",
  "parent_support|psikososyal destek programı terör": "DMVE",
  "parent_support|psikososyal destek programı doğal afet": "DMVE",
  "parent_support|psikososyal destek programı ölüm yas": "DMVE",
  "parent_support|rehberlik servisinin tanıtılması": "DMVE",
  "parent_support|sağlıklı yaşam": "DMVE",
  "parent_support|serbest zamanı değerlendirme": "DMVE",
  "parent_support|sınav kaygısı": "DMVE",
  "parent_support|stres yönetimi": "DMVE",
  "parent_support|şiddetin önlenmesi": "DMVE",
  "parent_support|tbm alkol bağımlılığı": "DMVE",
  "parent_support|tbm madde bağımlılığı": "DMVE",
  "parent_support|tbm sağlıklı yaşam": "DMVE",
  "parent_support|tbm teknoloji bağımlılığı": "DMVE",
  "parent_support|tbm tütün bağımlılığı": "DMVE",
  "parent_support|tek ebeveynlik": "DMVE",
  "parent_support|üst öğrenim kurumları": "DMVE",
  "parent_support|üst öğrenime geçiş sınavları": "DMVE",
  "parent_support|verimli ders çalışma teknikleri": "DMVE",
  "parent_support|zaman yönetimi": "DMVE",
  "teacher_support|akran arabuluculuğu": "DMÖE",
  "teacher_support|akran zorbalığı": "DMÖE",
  "teacher_support|anne baba tutumları": "DMÖE",
  "teacher_support|atılganlık": "DMÖE",
  "teacher_support|bep hazırlama": "DMÖE",
  "teacher_support|bilsem tanıtımı": "DMÖE",
  "teacher_support|bireyi tanıma teknikleri": "DMÖE",
  "teacher_support|bireysel farklılıklara saygı": "DMÖE",
  "teacher_support|çatışma çözme becerileri": "DMÖE",
  "teacher_support|çocuk hak ve sorumlulukları": "DMÖE",
  "teacher_support|çocuk ve ergenlerin gelişim özellikleri": "DMÖE",
  "teacher_support|çocuklar ve oyun": "DMÖE",
  "teacher_support|çocuklarda cinsel eğitim": "DMÖE",
  "teacher_support|davranış değiştirme teknikleri": "DMÖE",
  "teacher_support|destek eğitim odası hizmetleri": "DMÖE",
  "teacher_support|devamsızlığı önleme": "DMÖE",
  "teacher_support|dikkat geliştirme çalışmaları": "DMÖE",
  "teacher_support|eğitim koçluğu": "DMÖE",
  "teacher_support|engel türleri ve tanılama süreçleri": "DMÖE",
  "teacher_support|geleceği planlama": "DMÖE",
  "teacher_support|hak ve sorumluluklarını bilme": "DMÖE",
  "teacher_support|hedef belirleme": "DMÖE",
  "teacher_support|ihmal istismardan korunma": "DMÖE",
  "teacher_support|iletişim becerileri": "DMÖE",
  "teacher_support|iş yaşamına yönelik beceriler": "DMÖE",
  "teacher_support|işbirliği geliştirme": "DMÖE",
  "teacher_support|karar verme becerisi": "DMÖE",
  "teacher_support|kuşaklararası iletişim": "DMÖE",
  "teacher_support|motivasyon": "DMÖE",
  "teacher_support|olumlu davranış geliştirme": "DMÖE",
  "teacher_support|öfke yönetimi": "DMÖE",
  "teacher_support|öğrenci koçluk sistemi": "DMÖE",
  "teacher_support|öğrenme stilleri": "DMÖE",
  "teacher_support|öğretmen grubuyla vaka paylaşımı": "DMÖE",
  "teacher_support|özel eğitim gereksinimli öğrencilerin eğitim olanakları": "DMÖE",
  "teacher_support|özel eğitim gereksinimli öğrencilerin gelişim özellikleri": "DMÖE",
  "teacher_support|özgüven geliştirme": "DMÖE",
  "teacher_support|özsaygı geliştirme": "DMÖE",
  "teacher_support|problem çözme becerileri": "DMÖE",
  "teacher_support|psikososyal destek programı göç": "DMÖE",
  "teacher_support|psikososyal destek programı cinsel istismar": "DMÖE",
  "teacher_support|psikososyal destek programı intihar": "DMÖE",
  "teacher_support|psikososyal destek programı terör": "DMÖE",
  "teacher_support|psikososyal destek programı doğal afet": "DMÖE",
  "teacher_support|psikososyal destek programı ölüm yas": "DMÖE",
  "teacher_support|rehberlik servisinin tanıtılması": "DMÖE",
  "teacher_support|serbest zamanı değerlendirme": "DMÖE",
  "teacher_support|sınav kaygısı": "DMÖE",
  "teacher_support|sınıf rehberlik programı": "DMÖE",
  "teacher_support|sınıf yönetimi": "DMÖE",
  "teacher_support|stres yönetimi": "DMÖE",
  "teacher_support|tbm alkol bağımlılığı": "DMÖE",
  "teacher_support|tbm madde bağımlılığı": "DMÖE",
  "teacher_support|tbm sağlıklı yaşam": "DMÖE",
  "teacher_support|tbm teknoloji bağımlılığı": "DMÖE",
  "teacher_support|tbm tütün bağımlılı": "DMÖE",
  "teacher_support|üst öğrenim kurumları": "DMÖE",
  "teacher_support|üst öğrenime geçiş sınavları": "DMÖE",
  "teacher_support|verimli ders çalışma teknikleri": "DMÖE",
  "teacher_support|yetenek ilgi ve değerler": "DMÖE",
  "teacher_support|zaman yönetimi": "DMÖE",
  "consultancy_other|bağımlılıkla mücadele": "DMDE",
  "consultancy_other|çocuk ve ergenlerin gelişim özellikleri": "DMDE",
  "consultancy_other|ihmal istismar": "DMDE",
  "consultancy_other|iletişim becerileri": "DMDE",
  "consultancy_other|okula uyum çalışmaları": "DMDE",
  "consultancy_other|öfke yönetimi": "DMDE",
  "consultancy_other|özel eğitim gereksinimli öğrencilerin gelişim özellikleri": "DMDE",
  "consultancy_other|stres yönetimi": "DMDE",
  "consultancy_other|psikososyal destek programı göç": "DMDE",
  "consultancy_other|psikososyal destek programı cinsel istismar": "DMDE",
  "consultancy_other|psikososyal destek programı intihar": "DMDE",
  "consultancy_other|psikososyal destek programı terör": "DMDE",
  "consultancy_other|psikososyal destek programı doğal afet": "DMDE",
  "consultancy_other|psikososyal destek programı ölüm yas": "DMDE",
  "program_management|bep dosyalarının düzenlenmesi ve güncellenmesi": "DP",
  "program_management|bilsem danışman öğretmen belirlenmesi": "DP",
  "program_management|okul risk haritasının oluşturulması": "DP",
  "program_management|okul kurum rehberlik hizmetleri programının hazırlanması": "DP",
  "program_management|proje çalışmaları": "DP",
  "program_management|rehberlik hizmetleri yürütme komisyonu tarafından rehberlik ihtiyaç analizi çalışmalarının yapılması": "DP",
  "program_management|rehberlik hizmetleri yürütme komisyonu toplantısının yapılması": "DP",
  "program_management|rehberlik hizmetleri yürütme komisyonunun oluşturulması": "DP",
  "program_management|rehberlik servisi desimali oluşturulması": "DP",
  "program_management|rehberlik servisinin ihtiyaçlarının belirlenmesi": "DP",
  "cooperation_meetings|bep geliştirme birimi toplantıları": "DİT",
  "cooperation_meetings|değerler eğitimi komisyonu toplantısı": "DİT",
  "cooperation_meetings|destek eğitim odası toplantısı": "DİT",
  "cooperation_meetings|okul aile birliği toplantıları": "DİT",
  "cooperation_meetings|okul psikososyal koruma önleme ve krize müdahale toplantıları": "DİT",
  "cooperation_meetings|ram mesleki paylaşım toplantıları": "DİT",
  "cooperation_meetings|ram psikososyal koruma önleme ve krize müdahale toplantıları": "DİT",
  "cooperation_meetings|ram sene başı sonu toplantıları": "DİT",
  "cooperation_meetings|sınıf başarı değerlendirme toplantısı": "DİT",
  "cooperation_meetings|şube öğretmenler kurulu toplantıları": "DİT",
  "cooperation_meetings|veli toplantıları": "DİT",
  "cooperation_activities|aile katılımı çalışmaları": "DİF",
  "cooperation_activities|belirli gün ve haftalar ile ilgili çalışmalar": "DİF",
  "cooperation_activities|değerler eğitimi çalışmaları": "DİF",
  "cooperation_activities|mezuniyet": "DİF",
  "cooperation_activities|öğrenci meclisi çalışmaları": "DİF",
  "cooperation_activities|sağlık tarama çalışmaları": "DİF",
  "professional_development|bilimsel seminer konferansa katılma": "DG",
  "professional_development|hizmetiçi eğitim verme": "DG",
  "professional_development|hizmetiçi eğitime katılma": "DG",
  "professional_development|danışman öğretmenlik staj uygulamaları": "DG"
};


export const normalizeMebbisActivityLabel = (
  value
) => {

  return String(value ?? "")

    .replace(/\\r?\\n/g, " ")

    .replace(/\\s+/g, " ")

    .trim()

    .toLocaleLowerCase("tr-TR")

    .replace(/[“”"'’\`]/g, "")

    .replace(/[()]/g, " ")

    .replace(/[–—-]/g, " ")

    .replace(/[.,;:!?/\\\\]/g, " ")

    .replace(/\\s+/g, " ")

    .trim();
};


export const getExactMebbisCode = ({
  category,
  officialLabel
} = {}) => {

  if (
    !category ||
    !officialLabel
  ) {

    return null;
  }


  const key =
    `${category}|${normalizeMebbisActivityLabel(
      officialLabel
    )}`;


  return (
    MEBBIS_EXACT_CODE_MAP[
      key
    ] ||
    null
  );
};
